// File: cgp-idle.service.ts
// Author: Joseph M Diaz
// Date: 6/8/2017
// Desc: CGP Idle and Token Refresh timers.
// Other Contributors:

import { Injectable } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

import { config } from '../../../config/config';
import { cgpAuthentication } from '../../../modules/cgp-authentication';
import { CgpSnackbarService } from '../cgp-snackbar/cgp-snackbar.service';
import { CgpIdleDialogComponent } from './cgp-idle-dialog/cgp-idle-dialog.component';

@Injectable()
export class CgpIdleService {
    private readonly idleTimerConfig = config.idleTimer;
    private tokenRefreshTimer = null;
    private tokenTimer = null;
    private countdown = null;
    private timeLeft = null;
    private isActive = false;
    private logoutTime: Date = null;

    constructor(private readonly dialog: MatDialog, private readonly cgpSnackbarService: CgpSnackbarService) { }

    getLogoutTime(): Date {
        return this.logoutTime;
    }

    setIsActive() {
        this.isActive = true;
    }

    stayLoggedIn() {
        this.refreshToken();
        this.startTimers();
    }

    refreshToken() {
        cgpAuthentication.refreshToken((err, data) => {
            if (err) {
                this.cgpSnackbarService.showSnackbar({
                    message: 'Oops there was an error refreshing your session.',
                    action: 'LOG BACK IN',
                    duration: 10000,
                    onAction: () => {
                        window.location.replace(window.location.origin + window.location.pathname);
                    }
                });
                window.location.replace('#/logged-out');
            }
        });
    }

    startTimers() {
        this.startTokenRefreshTimer();
        this.startTokenTimer();
    }

    clearTimers() {
        this.clearTokenRefreshTimer();
        this.clearTokenTimer();
        this.clearCountdown();
    }

    startTokenRefreshTimer() {
        const timerInterval = this.idleTimerConfig.tokenRefreshInterval;

        this.clearTokenRefreshTimer();
        this.tokenRefreshTimer = setInterval(() => {
            if (this.isActive) {
                this.refreshToken();
                this.startTokenTimer();
            }

            this.isActive = false;
        }, timerInterval * 60000);
    }

    clearTokenRefreshTimer() {
        this.isActive = false;
        clearInterval(this.tokenRefreshTimer);
    }

    startTokenTimer() {
        const warningInterval = this.idleTimerConfig.timeoutInterval - this.idleTimerConfig.warningTime;

        this.clearTokenTimer();

        if (warningInterval <= 0) {
            throw new Error('idleTimerConfig.timeoutInterval must be greater than idleTimerConfig.warningTime.');
        }

        this.logoutTime = new Date();
        this.logoutTime.setSeconds(this.logoutTime.getSeconds() + this.idleTimerConfig.timeoutInterval * 60);

        this.tokenTimer = setInterval(() => {
            this.clearTokenRefreshTimer();
            this.clearTokenTimer();
            this.startCountdown();
        }, warningInterval * 60000);
    }

    clearTokenTimer() {
        clearInterval(this.tokenTimer);
        this.clearCountdown();
    }

    startCountdown() {
        this.timeLeft = this.idleTimerConfig.warningTime * 60;
        this.clearCountdown();
        this.showIdleDialog();
        this.countdown = setInterval(() => {
            this.timeLeft--;

            if (this.timeLeft < 1) {
                this.clearCountdown();
                window.location.replace('#/logged-out');
            }
        }, 1000);
    }

    clearCountdown() {
        clearInterval(this.countdown);
    }

    showIdleDialog() {
        let dialogRef: MatDialogRef<CgpIdleDialogComponent>;

        dialogRef = this.dialog.open(CgpIdleDialogComponent, {

            disableClose: true
        });
        dialogRef.componentInstance.serviceRef = this;
        dialogRef.componentInstance.countdown = this.timeLeft;
    }
}
